import { Hint } from "react-ui";
import * as React from "react";

import { Icon } from "../../Icons/Icon";

import { BaseCard, TextInCard } from "./FormInfo.styles";
import { htmlWithLinkToTextOrNode } from "./ActualInfoAboutForm";
import { bannerMaxWidth } from "./LinkInfo";
export interface DateReleaseProps {
    dateRelease: string | undefined;
}
export const DateRelease = (props: DateReleaseProps) => {
    const splitDateRelease = props.dateRelease?.split("|");

    return (
        <Hint
            text={htmlWithLinkToTextOrNode(splitDateRelease?.[1] ? <div>{splitDateRelease?.[1]}</div> : "")}
            pos={"bottom left"}
            maxWidth={bannerMaxWidth}
            useWrapper={true}>
            <BaseCard>
                <Icon name={"SendPaperplaneDiagIcon"} />
                <TextInCard>Отправка появится с {splitDateRelease?.[0]}</TextInCard>
            </BaseCard>
        </Hint>
    );
};
